import { GuardMeDashboard } from "@/features/dashboard/guardme-dashboard";

export const Route = createFileRoute({
  component: GuardMeDashboard,
});
